import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "tss-react/mui";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import IconButton from "@mui/material/IconButton";
import AttachmentIcon from "@mui/icons-material/AttachFile";

import config from "./config.json";
import { useFeedback } from "./Feedback";
import { HTTP, HTTPMethod } from "./Backend";

interface ShowAttachmentProperties {
  songid: number | null;
}

const useStyles = makeStyles()((theme) => ({
  link: {
    margin: theme.spacing(1),
    color: theme.palette.text.primary
  }
}));

export interface Attachment {
    attachmentid: number;
    attachmentfilename: string;
};

export default function ShowAttachments(props: ShowAttachmentProperties) {

  const { classes } = useStyles();
  const [attachments, setAttachments] = useState<Attachment[]>([]);
  const feedback = useRef(useFeedback());

  useEffect(() => {
    if ((props.songid === 0) || (props.songid === null)) {
        setAttachments([]);
    } else  {
        HTTP(HTTPMethod.GET, config.urlGetAttachments + "/" + props.songid)
        .then(json => {
            let result:Attachment[] = [];
            for (let record of json) {
                const row:Attachment = {
                  attachmentid: record.attachmentid,
                  attachmentfilename: record.attachmentfilename
                };
                result.push(row);
            }
            setAttachments(result);
        })
        .catch(error => {
            feedback.current(error);
        })
    }
  }, [props.songid]);


  return (
    <div>
        {attachments.map((attachment) => {
            return (
                <Typography key={attachment.attachmentid}>
                    <IconButton
                        href={config.urlGetAttachment + "/" + attachment.attachmentid}
                    >
                        <AttachmentIcon/>
                    </IconButton>
                    <Link className={classes.link} href={config.urlGetAttachment + "/" + attachment.attachmentid}>
                        {attachment.attachmentfilename}
                    </Link>
                </Typography>
            )}
        )}
    </div>
  );
}